import { reportBlockService } from '../report-block.service'

class SankeyBlockService {
  getLabels (report, blockKey, props) {
    const { stages, states } = getLabelsFromDatasetMetadata(report, blockKey)

    const stageLabels = reportBlockService.getTheRightConfiguration(stages, props.stageLabels)
    const stateLabels = reportBlockService.getTheRightConfiguration(states, props.stateLabels)

    return {
      stageLabels,
      stateLabels
    }
  }
}

function getLabelsFromDatasetMetadata (report, blockKey) {
  const currentBlock = report.layout.blocks.find(({ key }) => (blockKey === key))
  const dataKey = currentBlock.dataKey
  const stages = report.parent.dataSets[dataKey] && report.parent.dataSets[dataKey].dataLabels && report.parent.dataSets[dataKey].dataLabels.stages
  const states = report.parent.dataSets[dataKey] && report.parent.dataSets[dataKey].dataLabels && report.parent.dataSets[dataKey].dataLabels.states

  return { stages, states }
}

export const sankeyBlockService = new SankeyBlockService()
